export const normalFeature = {
  weight: 1,
  opacity: 1,
  color: 'white',
  fillOpacity: 0.7,
  fillColor: '#2387ca'
};

export const highlightedFeature = {
  weight: 3,
  color: 'white',
  fillOpacity: 1,
  fillColor: '#2387ca'
};

export const visibleStyle = () => {
  return normalFeature;
};
